import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logo-onecbm.png'
import _imports_1 from '../../assets/TotalEnergies_logo.svg'


const _hoisted_1 = { class: "navigation d-flex align-items-md-center" }
const _hoisted_2 = { class: "logos flex items-center" }
const _hoisted_3 = { class: "items-center row" }
const _hoisted_4 = { class: "country-site d-flex" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "120",
  height: "87",
  alt: "TotalEnergies",
  class: "total-logo"
}, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_AlertsIcon = _resolveComponent("AlertsIcon")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, {
    class: "bg-white text-black row main-header",
    reveal: "",
    elevated: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_toolbar, { class: "row" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "applogo",
                src: _imports_0,
                alt: "OneCBM",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetSite && _ctx.resetSite(...args)))
              })
            ]),
            (_ctx.account && _ctx.getSelectedSite)
              ? (_openBlock(), _createBlock(_component_q_tabs, {
                  key: 0,
                  align: "left",
                  "active-color": "primary",
                  class: "menu",
                  elevated: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_route_tab, {
                      to: {
              name: 'EquipmentList',
              params: {
                countryBloc: _ctx.getSelectedCountryBloc,
                site: _ctx.getSelectedSite,
              },
            },
                      label: "Equipment list"
                    }, null, 8 /* PROPS */, ["to"]),
                    _createVNode(_component_q_route_tab, {
                      to: {
              name: 'EquipmentDetails',
              params: {
                countryBloc: _ctx.getSelectedCountryBloc,
                site: _ctx.getSelectedSite,
              },
            },
                      label: "Equipment Details"
                    }, null, 8 /* PROPS */, ["to"]),
                    _createVNode(_component_q_route_tab, {
                      to: {
              name: 'EquipmentReporting',
              params: {
                countryBloc: _ctx.getSelectedCountryBloc,
                site: _ctx.getSelectedSite,
              },
            },
                      label: "Reporting"
                    }, null, 8 /* PROPS */, ["to"]),
                    _createVNode(_component_q_route_tab, {
                      to: {
              name: 'QuickDashboard',
              params: {
                countryBloc: _ctx.getSelectedCountryBloc,
                site: _ctx.getSelectedSite,
              },
            },
                      label: "Quick Dashboard"
                    }, null, 8 /* PROPS */, ["to"]),
                    _createVNode(_component_q_route_tab, {
                      to: {
              name: 'AutomaticStatus',
              params: {
                countryBloc: _ctx.getSelectedCountryBloc,
                site: _ctx.getSelectedSite,
              },
            },
                      label: "Automatic Status Update"
                    }, null, 8 /* PROPS */, ["to"]),
                    (!_ctx.isUserOffshore())
                      ? (_openBlock(), _createBlock(_component_q_route_tab, {
                          key: 0,
                          to: {
              name: 'EquipmentAlerting',
              params: {
                countryBloc: _ctx.getSelectedCountryBloc,
                site: _ctx.getSelectedSite,
              },
            },
                          label: "Equipment Alerts",
                          class: "equipmentAlertsTab"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.account && _ctx.getSelectedSite)
                              ? (_openBlock(), _createBlock(_component_AlertsIcon, {
                                  key: 0,
                                  "display-total": true,
                                  class: "headerAlertIcon"
                                }))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.getSelectedSite)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.getCountryBlock()), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.getSelectedSite)
                  ? (_openBlock(), _createBlock(_component_q_select, {
                      key: 1,
                      modelValue: _ctx.selectedSite,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSite) = $event)),
                      borderless: "",
                      options: _ctx.assignedSites
                    }, null, 8 /* PROPS */, ["modelValue", "options"]))
                  : _createCommentVNode("v-if", true)
              ]),
              (_ctx.account)
                ? (_openBlock(), _createBlock(_component_Avatar, {
                    key: 0,
                    id: "avatar"
                  }))
                : _createCommentVNode("v-if", true),
              _hoisted_6
            ])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}